export { PagerComponent } from './pager.component';
export { PaginationComponent } from './pagination.component';
export { PaginationModule } from './pagination.module';
export { PaginationConfig } from './pagination.config';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /code/frontend/~/ng2-bootstrap/pagination/index.js
// module id = ../../../../ng2-bootstrap/pagination/index.js
// module chunks = 4